import Vue from 'vue'
import User from '../models/user'
import ApiBase from '@/api/apiBase'


class ApiUsers {

  static all(callBack, errorCallBack){
    ApiBase.get(`/users`, callBack, ApiUsers.parseAll, errorCallBack)
  }

  static parseAll(response){
    var result = []
    for(var i in response.data.data){
      result.push(User.parse(response.data.data[i]))
    }
    return result
  }

  static find(userID, callBack, errorCallBack){
    ApiBase.get(`/users/${userID}`, callBack, ApiUsers.parseFind, errorCallBack)
  }

  static parseFind(response){
    return User.parse(response.data.data)
  }

  static create(user, callBack, errorCallBack){
    let data = {
      name : user.name,
      lastname : user.lastname,
      phone : user.phone,
      email : user.email,
      password : user.password
    }
    ApiBase.post(`/users`, data, callBack, ApiBase.noParse, errorCallBack)
  }


  static update(user, callBack, errorCallBack){
    var data = {
      name : user.name,
      lastname : user.lastname,
      phone : user.phone,
      email : user.email
    }
    if (user.password.length > 0) {
      data.password = user.password
    }
    ApiBase.put(`/users/${user.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }

  static active(user, callBack, errorCallBack){
    var data = {
      active : user.active == 1 ? 0 : 1
    }
    ApiBase.put(`/users/${user.id}`,data,callBack,ApiBase.noParse,errorCallBack)
  }


  static delete(user, callBack, errorCallBack){
    ApiBase.delete(`/users/${user.id}`,callBack,ApiBase.noParse,errorCallBack)
  }

}

export default ApiUsers



// WEBPACK FOOTER //
// ./src/api/apiUsers.js